import React from "react";
import Backdrop from "../Backdrop/Backdrop";
import partyPopper from "../../../assets/partyPopper.svg";
import qrCode from "../../../assets/qrCode.svg";
import styles from "./Owner.module.scss";

const Owner = ({ setIsModalOpen }) => {
  return (
    <div className={styles.mainContainer}>
      <Backdrop />
      <div className={styles.container}>
        <span onClick={() => setIsModalOpen(false)}>&times;</span>
        <div className={styles.content}>
          <img src={partyPopper} alt="popper" />

          <p>Now you’re the owner of Cryptographics #1267</p>

          <div className={styles.qr}>
            <img src={qrCode} alt="qr-code" />
            <h4>Scan QR code</h4>
          </div>

          <button>Download</button>
        </div>
      </div>
    </div>
  );
};

export default Owner;
